module.exports = __webpack_public_path__ + "media/F_1.4eebfacb.mp3";